import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StudentJourneyService {
  private apiUrl = environment.apiUrl;;

  constructor(private _http:HttpClient) { }

  /* Getting the student data */
  getStudentJourney():Observable<any[]> {
    return this._http.get<any[]>(`${this.apiUrl}gameplan/getGameplanTopic`);
  }
}
